import { Input, Modal } from 'antd';
import { useState } from 'react';

import { whitespaceRegex } from '../Constants/index';
import Button from './UI/Button';

const Content = ({
  onClose,
  initialText,
  loading,
  onSave,
  submitText = 'Save',
  cancelText = 'Cancel',
  renderHeader,
  renderLabel,
  submitButtonProps,
}) => {
  const [formData, setFormData] = useState({
    input: initialText,
    error: null,
  });

  function handleChange(e) {
    setFormData((prevData) => ({
      ...prevData,
      input: e.target.value,
      ...(formData.error ? { error: null } : {}),
    }));
  }

  function validate() {
    let isValidate = true;
    if (!formData.input) {
      setFormData((prevData) => ({ ...prevData, error: 'Write Something!' }));
      isValidate = false;
    } else if (whitespaceRegex.test(formData.name)) {
      setFormData((prevData) => ({ ...prevData, error: 'Invalid Input' }));
      isValidate = false;
    }
    return isValidate;
  }

  function onSubmit(e) {
    e.preventDefault();
    if (validate()) {
      onSave(formData.input);
      // setFormData((prev) => ({ ...prev, input: null, error: null }));
    }
  }

  return (
    <form onSubmit={onSubmit} id='form_update_text' style={{ width: '100%' }}>
      {renderHeader && renderHeader()}
      <Input
        value={formData.input}
        onChange={handleChange}
        style={{ borderRadius: '4px' }}
        autoFocus
      />
      {formData.error && <div className='color-danger'>{formData.error}</div>}
      {renderLabel && renderLabel()}
      <div className='flex' style={{ marginTop: '1.5rem', gap: '12px' }}>
        <Button
          type='primary'
          className='btn-s'
          onClick={onSubmit}
          loading={loading}
          {...submitButtonProps}
        >
          {submitText}
        </Button>
        <Button type='default' danger className='btn-s' onClick={onClose}>
          {cancelText}
        </Button>
      </div>
    </form>
  );
};

const UpdateTextModal = ({
  width = 500,
  isOpen,
  onClose,
  onSave,
  initialText = '',
  loading = false,
  submitText = 'Save',
  cancelText = 'Cancel',
  centered = false,
  renderHeader,
  renderLabel,
  submitButtonProps,
}) => {
  return (
    <Modal
      open={isOpen}
      width={width}
      footer={null}
      onCancel={onClose}
      closeIcon={null}
      centered={centered}
      destroyOnHidden
    >
      <Content
        onClose={onClose}
        initialText={initialText}
        loading={loading}
        onSave={onSave}
        submitText={submitText}
        cancelText={cancelText}
        submitButtonProps={submitButtonProps}
        renderHeader={renderHeader}
        renderLabel={renderLabel}
      />
    </Modal>
  );
};

export default UpdateTextModal;
